/* Studio L wishlist — localStorage based, synced to the customer account
   (metafield via sync worker) when the visitor is logged in. */
(function () {
  'use strict';

  var KEY = 'studiol:wishlist';
  var account = window.StudioLWishlistAccount || null;
  var syncTimer;

  function read() {
    try {
      var items = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(items) ? items : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
    } catch (e) {
      /* private mode — wishlist simply won't persist */
    }
    scheduleSync();
  }

  function scheduleSync() {
    if (!account || !account.endpoint) return;
    clearTimeout(syncTimer);
    syncTimer = setTimeout(pushToAccount, 800);
  }

  function pushToAccount() {
    if (!account || !account.endpoint) return;
    var payload = JSON.stringify({
      customerId: account.customerId,
      token: account.token,
      handles: read()
    });
    /* text/plain keeps this a "simple" CORS request (sendBeacon can't preflight) */
    if (navigator.sendBeacon) {
      navigator.sendBeacon(account.endpoint, new Blob([payload], { type: 'text/plain' }));
      return;
    }
    fetch(account.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      body: payload,
      keepalive: true
    }).catch(function () { /* retried on next change */ });
  }

  /* Logged in: merge the account wishlist (other devices / earlier visits)
     with whatever was saved locally, then push the union back. */
  function mergeAccountWishlist() {
    if (!account || !Array.isArray(account.saved)) return;
    var local = read();
    var merged = account.saved.slice();
    local.forEach(function (handle) {
      if (merged.indexOf(handle) === -1) merged.push(handle);
    });
    try {
      localStorage.setItem(KEY, JSON.stringify(merged));
    } catch (e) { /* ignore */ }
    if (merged.length !== account.saved.length) scheduleSync();
  }

  function refreshCounts() {
    var items = read();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = items.length;
      el.classList.toggle('is-empty', items.length === 0);
    });
  }

  function refreshButtons(root) {
    var items = read();
    (root || document).querySelectorAll('[data-wishlist-button]').forEach(function (btn) {
      var active = items.indexOf(btn.getAttribute('data-product-handle')) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function bumpHeader() {
    document.querySelectorAll('[data-wishlist-header]').forEach(function (el) {
      el.classList.remove('is-bumping');
      // restart the animation
      void el.offsetWidth;
      el.classList.add('is-bumping');
    });
  }

  function toggle(handle) {
    var items = read();
    var index = items.indexOf(handle);
    if (index === -1) {
      items.push(handle);
    } else {
      items.splice(index, 1);
    }
    write(items);
    refreshCounts();
    refreshButtons();
    return index === -1;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-wishlist-button]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();

    var added = toggle(btn.getAttribute('data-product-handle'));
    btn.classList.remove('is-animating');
    void btn.offsetWidth;
    btn.classList.add('is-animating');
    if (added) bumpHeader();
  });

  document.addEventListener('animationend', function (event) {
    if (event.target.closest && event.target.closest('[data-wishlist-button]')) {
      var btn = event.target.closest('[data-wishlist-button]');
      btn.classList.remove('is-animating');
    }
  });

  /* Wishlist page — render saved products with the theme's own grid item section */
  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;

    var empty = document.querySelector('[data-wishlist-empty]');
    var items = read();

    if (items.length === 0) {
      if (empty) empty.removeAttribute('hidden');
      grid.setAttribute('hidden', '');
      return;
    }
    if (empty) empty.setAttribute('hidden', '');
    grid.removeAttribute('hidden');

    items.forEach(function (handle) {
      fetch(window.theme.routes.root + 'products/' + handle + '?section_id=api-product-grid-item')
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (html) {
          var holder = document.createElement('div');
          holder.innerHTML = html;
          var content = holder.querySelector('[data-api-content]');
          if (!content) return;
          while (content.firstElementChild) {
            grid.appendChild(content.firstElementChild);
          }
          refreshButtons(grid);
        })
        .catch(function () {
          /* product removed or unavailable — drop it silently */
        });
    });
  }

  function init() {
    mergeAccountWishlist();
    refreshCounts();
    refreshButtons();
    renderWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Grids re-rendered by AJAX (filters, tabs, quick view) — keep hearts in sync */
  var debounce;
  new MutationObserver(function () {
    clearTimeout(debounce);
    debounce = setTimeout(function () {
      refreshButtons();
      refreshCounts();
    }, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
